import React from 'react';
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../service/ToolsService";

export const Tab = () => {
  return (
    <>
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <NavLink to={`/admin/route/route`} onClick={scrollTo} className="nav-link">
            <i className="fa-solid fa-person-biking me-1"/> Parcours
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to={`/admin/route/circuit`} onClick={scrollTo} className="nav-link">
            <i className="fa-solid fa-map-location-dot me-1"/> Circuits
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to={`/admin/route/step`} onClick={scrollTo} className="nav-link">
            <i className="fa-solid fa-map-pin me-1"/> Etapes
          </NavLink>
        </li>
      </ul>
    </>
  );
}
